import React, { FC } from "react";
import { useDeviceOptionsStore } from "../../../storez/DeviceOptionsStore";
import { Img } from "@chakra-ui/image";
import linewizeLogo from "../../../../images/logos/Logos-_Linewize_Logo_Application.svg";
import SmoothwallLogo from "../../../../images/logos/Logos-_Smoothwall_Logo_Application.svg";

/**
 * HeaderLogo component that displays different logos based on device options.
 *
 * If the `customer_internal_company` is "Smoothwall" (case-insensitive), it displays the Smoothwall logo.
 * For any other value of `customer_internal_company`, including undefined or null, it displays the Linewize logo.
 */
export const HeaderLogo: FC = () => {
  const commonProps = {
    paddingX: "24px",
    "data-testid": "logo-image",
  };

  const deviceOptions = useDeviceOptionsStore((state) => state.options);

  // Show Smoothwall logo only if device options are available and company is "smoothwall"
  const isSmoothwallBranding = deviceOptions?.customer_internal_company?.toLowerCase() === "smoothwall";

  if (isSmoothwallBranding) {
    return <Img {...commonProps} src={SmoothwallLogo} alt="Smoothwall Logo" />;
  }

  // Default to Linewize logo
  return <Img {...commonProps} src={linewizeLogo} alt="Linewize Logo" />;
};
